@if (preloader) { 
<div  id="preloader">
    <div id="loader">
      <img src="../../../../assets/images/preLoader1.gif" height="300px; width:300px" />
    </div>
  </div>
}

